import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Rocket } from 'lucide-react';
import { Button, SectionHeading } from './ui';
import { useCheckout } from './checkout-context';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Una vez confirmado el pago, recibirás un correo electrónico inmediatamente con el enlace para descargar todos los archivos en formato PDF, listos para imprimir.'
}, {
  q: '¿Sirve para principiantes?',
  a: '¡Sí! El kit está diseñado paso a paso, comenzando desde los trazos más básicos hasta la lectura y matemáticas iniciales.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí, es un único pago. No hay suscripciones ni cobros mensuales. Una vez que lo compras, el material es tuyo para siempre.'
}, {
  q: '¿Funciona para niños de qué edad?',
  a: 'El material está diseñado y recomendado para niños de 3 a 10 años, abarcando diferentes etapas de aprendizaje.'
}, {
  q: '¿Puedo imprimir las veces que quiera?',
  a: '¡Por supuesto! Puedes descargar los archivos y guardar copias para imprimir las páginas cuantas veces lo necesites.'
}, {
  q: '¿Sirve para usar en aulas?',
  a: 'Es ideal para docentes. Puedes utilizar las fichas como material de apoyo, tareas para el hogar o actividades en clase.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4" data-id="element-135">
        <SectionHeading data-id="element-136">Preguntas Frecuentes</SectionHeading>

        <div className="space-y-4" data-id="element-137">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-200 rounded-2xl overflow-hidden" data-id="element-138">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center bg-white hover:bg-slate-50 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-139">
                <span className="font-bold text-brand-navy text-lg pr-4" data-id="element-140">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-blue transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-141" />
              </button>
              <AnimatePresence data-id="element-142">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-143">
                    <div className="px-6 pb-5 text-slate-600 border-t border-slate-100 pt-4" data-id="element-144">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};
export const FinalCTA = () => {
  const {
    requestCheckout
  } = useCheckout();
  return <section className="py-24 bg-brand-blue relative overflow-hidden" data-id="element-145">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-146" />
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-147">
        <div className="inline-block bg-white/20 backdrop-blur-sm text-white font-bold px-6 py-2 rounded-full mb-8" data-id="element-148">
          COLECCIÓN APRENDO Y ME DIVIERTO
        </div>
        <h2 className="font-heading text-5xl md:text-6xl text-white mb-10 leading-tight" data-id="element-149">
          Aprender jugando es el mejor regalo que podemos darles.
        </h2>
        <Button size="xl" variant="primary" onClick={requestCheckout} className="shadow-2xl" data-id="element-150">
          <Rocket className="w-6 h-6 mr-3" data-id="element-151" />
          QUIERO MI KIT EDUCATIVO AHORA
        </Button>
      </div>
    </section>;
};
export const Footer = () => <footer className="bg-brand-navy py-8 text-center text-white/60 text-sm" data-id="element-152">
    <div className="max-w-7xl mx-auto px-4" data-id="element-153">
      <p className="mb-4" data-id="element-154">
        © {new Date().getFullYear()} Colección Aprendo y Me Divierto. Todos los
        derechos reservados.
      </p>
      <div className="flex justify-center gap-6" data-id="element-155">
        <a href="#" className="hover:text-white transition-colors" data-id="element-156">
          Términos y Condiciones
        </a>
        <a href="#" className="hover:text-white transition-colors" data-id="element-157">
          Políticas de Privacidad
        </a>
        <a href="#" className="hover:text-white transition-colors" data-id="element-158">
          Contacto
        </a>
      </div>
    </div>
  </footer>;
export const MobileStickyCTA = () => {
  const {
    requestCheckout
  } = useCheckout();
  return <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-slate-200 p-4 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 flex items-center justify-between" data-id="element-159">
      <div data-id="element-160">
        <div className="text-xs text-slate-500 line-through" data-id="element-161">$360.000</div>
        <div className="font-heading text-2xl text-brand-navy" data-id="element-162">$21.999</div>
      </div>
      <Button size="lg" onClick={requestCheckout} className="py-3 px-6" data-id="element-163">
        Comprar ahora
      </Button>
    </div>;
};